import { render } from "./PublishPage.vue?vue&type=template&id=6594b36e&scoped=true"
import script from "./PublishPage.vue?vue&type=script&lang=js"
export * from "./PublishPage.vue?vue&type=script&lang=js"

import "./PublishPage.vue?vue&type=style&index=0&id=6594b36e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6594b36e"]])

export default __exports__